export const openFooterAccordion = (item) => {
  const accordionGroups = document.getElementsByClassName('footer__nav-group');

  for (const group of accordionGroups) {
    if (group === item) {
      group.classList.toggle('active');
    } else {
      group.classList.remove('active');
    }
  }
}

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}

// Add event listener to .action-bar element to scroll to top
const actionBar = document.querySelector('.action-bar');
if (actionBar) {
  actionBar.addEventListener('click', () => {
    scrollToTop();
  });
}

// Add event listeners to all footer__nav-group elements
const accordionGroups = document.getElementsByClassName('footer__nav-group');
for (const group of accordionGroups) {
  group.addEventListener('click', () => {
    openFooterAccordion(group);
  });
}
